<template>
  <span>
    <sup class="is-inline-block" v-if="stars && stars > 0" v-html="formattedStars"></sup>
    <span class="is-sr-only">{{ stars }} {{ $t('general.stars') }}</span>
  </span>
</template>

<script>
export default {
  name: 'StarDisplay',
  props: {
    stars: Number,
  },
  computed: {
    formattedStars: function() {
      let ret = ''
      let stars = this.stars
      if (stars > 0) {
        if (stars <= 3) {
          for (let i = 0; i < Math.floor(stars); i++) {
            ret += '<span class="icon"> <i class="fas fa-star"></i></span>'
          }
        } else {
          for (let i = 0; i < Math.ceil((2 + stars) / 2); i++) {
            ret += '<span class="icon"> <i class="fas fa-star"></i></span>'
          }
          if (stars % 2 == 0) {
            ret += ' sup'
          }
        }
      }
      return ret
    },
  },
}
</script>

<style scoped lang="sass"></style>
